import type { ReactNode } from 'react'
import type { SectionId } from '../../data/assets'
import styles from './SectionScaffold.module.css'

interface SectionScaffoldProps {
  id: SectionId
  children?: ReactNode
  className?: string
  labelledBy?: string
}

export function SectionScaffold({
  id,
  children,
  className = '',
  labelledBy,
}: SectionScaffoldProps): ReactNode {
  return (
    <section
      id={id}
      className={`${styles.section} ${className}`.trim()}
      aria-labelledby={labelledBy}
      data-section={id}
    >
      {children}
    </section>
  )
}
